import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class ActivityLogService {
  DoGetActivityLog(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Log/GetLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoCreateActivityLog(activityLog: Record<string, any>) {
    const activityLogList: Array<Record<string, any>> = [];
    activityLogList.push({
      activityLogActionType: activityLog.activityLogActionType,
      referenceId: activityLog.referenceId,
      referenceId2: activityLog.referenceId2,
      note1: activityLog.note1,
      note2: activityLog.note2,
    });
    const _input = activityLogList;
    return service.peakLogAPI.post("/api/ActivityLog/InsertActivityLog", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new ActivityLogService();
